import { linkOptions } from '@tanstack/react-router';

/** The folder a path sits in; the root for a bare name. */
export function parentFolderOf(path: string): string {
  const cut = path.lastIndexOf('/');
  return cut === -1 ? '' : path.slice(0, cut);
}

/**
 * Where "open this file" goes: the browser with the file selected, its folder
 * listed and the preview showing — the same destination the Overview's
 * recent-changes rows build, so a path linked from prose (spec 095 FR-018)
 * and a path linked from a change row arrive at the same place.
 */
export function filePreviewLink(workspaceId: string, path: string) {
  return linkOptions({
    to: '/workspaces/$workspaceId/files',
    params: { workspaceId },
    search: {
      path: parentFolderOf(path),
      file: path,
      view: 'preview' as const,
    },
  });
}
